import axios from '@/helpers/axios';

export function getDoctorsAndCount(options) {
  return axios.post('/dealer/doctors/list', options).then(({ data }) => {
    return {
      doctors: data.results,
      count: data.count,
    };
  });
}

export function getDoctorById(id) {
  return axios
    .post('/dealer/doctors/get', {
      id,
    })
    .then(({ data }) => {
      return data.doctor;
    });
}

export function addDoctor(doctor) {
  return axios
    .post('/dealer/doctors/create', {
      doctor,
    })
    .then(({ data }) => {
      return data.doctor;
    });
}

export function updateDoctor(doctor) {
  if (!doctor.user.password) {
    delete doctor.user.password;
  }

  return axios
    .post('/dealer/doctors/update', {
      id: doctor.userId,
      doctor,
    })
    .then(({ data }) => {
      return data.doctor;
    });
}

export function deleteDoctorById(id) {
  return axios.post('/dealer/doctors/delete', {
    id,
  });
}
